__turbopack_context__.v({
  "button": "BackToTop-module__mHfsmG__button",
});
